import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Loader } from 'lucide-react'
import useAuthStore from '../store/auth-store'

export function ProtectedRoute({ children }) {
  const { isAuthenticated, sessionLogin } = useAuthStore()
  const location = useLocation()

  // No JWT yet → try a silent session exchange ONCE before giving up. This logs
  // in users who already have a Django session (e.g. an admin opening a clean
  // /dashboard/project/<id>/ link from the admin panel) without a second prompt.
  // While that request is in flight we show a spinner rather than flashing the
  // login page. If it fails, we send them to /login and remember where they were
  // headed, so login returns them to the project they clicked.
  const [checking, setChecking] = useState(!isAuthenticated)

  useEffect(() => {
    let cancelled = false
    if (!isAuthenticated) {
      sessionLogin().finally(() => { if (!cancelled) setChecking(false) })
    }
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isAuthenticated) return children

  if (checking) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#F1F2F4]">
        <Loader className="w-6 h-6 animate-spin text-[#358ECD]" />
      </div>
    )
  }

  return <Navigate to="/login" replace state={{ from: location }} />
}
